import { BooksProduct, isBooksProduct } from 'src/api/booksProducts'
import { HandoutPreviewImageDTO, IProduct } from 'src/api/product'

export default function getPreviewImage(
	product: IProduct | BooksProduct,
): HandoutPreviewImageDTO[] | null {
	const isBooks = isBooksProduct(product)
	if (isBooks) {
		return null
	} else if (typeof product.source.images === 'object' && 'previews' in product.source.images) {
		return product.source.images.previews as HandoutPreviewImageDTO[]
	} else {
		return []
	}
}
